<template>
	<div class="stock_tab">
		<div ref="tabBox" class="tab_box">
			<button
				v-for="(item, idx) in props.tab"
				ref="tabBox"
				:key="idx"
				class="tab_item"
				:value="item.tab"
				:class="Number(currentSubTab) === idx && 'selected'"
				@click="onStockTabClick(idx, $event)"
			>
				{{ item.tab }}
			</button>
		</div>
		<button
			class="btn_tooltip"
			@mousemove="deviceStore.getDevice === 'MO' ? (isTooltipOpened = !isTooltipOpened) : (isTooltipOpened = true)"
			@mouseout="isTooltipOpened = false"
		>
			<img src="@/assets/img/common/question.svg" alt="도움말" loading="lazy" />
		</button>
		<div v-if="isTooltipOpened" class="c_tooltip">
			<p class="c_tooltip_title">{{ MARKET_CAP_CRITERIA }}</p>
			<ul class="c_tooltip_content">
				<li v-for="(item, index) in STOCK_MENU_TAB" :key="index" class="c_tooltip_content_item">
					<p class="c_tooltip_content_title">{{ item.tab }}</p>
					<p class="c_tooltip_content_description" v-dompurify-html="item.unit"></p>
				</li>
			</ul>
		</div>
	</div>
</template>
<script setup lang="ts">
// core
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

// constant
import { MARKET_CAP_CRITERIA, STOCK_MENU_TAB, tabType } from '@/constants/title';
import { useDeviceStore } from '@/stores/device';
// define
const props = defineProps<{
	tab: tabType[];
}>();

// -----variable-----
const emit = defineEmits(['update:masterEvent']);

const route = useRoute();
const deviceStore = useDeviceStore();

const tabBox = ref<HTMLDivElement | null>(null);
const isTooltipOpened = ref(false);
const currentSubTab = computed(() => {
	return route.query.tab ?? 0;
});

// -----function-----
// HTML 요소를 중앙에 위치시키는 함수
const scrollToCenter = (element: HTMLElement) => {
	if (tabBox.value) {
		const container = tabBox.value;
		const containerWidth = container.clientWidth;
		const elementWidth = element.clientWidth;
		const elementLeft = element.offsetLeft;
		const scrollPosition = elementLeft - containerWidth / 2 + elementWidth / 2;
		container.scrollTo({
			left: scrollPosition,
			behavior: 'smooth',
		});
	}
};

// 주식 탭 클릭 시 함수
const onStockTabClick = async (tab: number, event: Event) => {
	const target = event.target as HTMLElement;
	scrollToCenter(target);
	emit('update:masterEvent', tab);
};
</script>
<style lang="scss" scoped>
.stock_tab {
	display: flex;
	flex-direction: row;
	position: relative;
	white-space: nowrap;
	width: 100%;
	border-bottom: 1px solid #393d45;
	&::-webkit-scrollbar {
		display: none;
	}
	.tab_box {
		width: 100%;
		display: flex;
		flex-direction: row;
		max-width: 68rem;
		overflow: scroll;
		.tab_item {
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-medium);
			line-height: 1.7;
			color: var(--color-font-white);
			display: flex;
			flex: 1;
			align-items: center;
			justify-content: center;
			height: 5.2rem;
			white-space: nowrap;
			padding: 1.2rem;
		}
	}
	.tab_box::-webkit-scrollbar {
		display: none;
	}
	.selected {
		color: var(--color-primary);
		border-bottom: 1px solid var(--color-primary);
	}
	.btn_tooltip {
		flex: 0.1;
		@media screen and (max-width: 1280px) {
			flex: 0.2;
			padding-right: 2rem;
		}
	}
	img {
		width: 2.4rem;
		height: 2.4rem;
	}
	.c_tooltip {
		top: 103%;
		right: 0;
		:deep(.c_tooltip_content_description strong) {
			color: var(--color-secondary);
			font-weight: var(--font-w-medium);
		}
	}
}
</style>
